'use client';

import React__default, { useState, useEffect } from 'react';
import RemoveIcon from '../Images/RemoveIcon/index.js';
import Popup from '../Popup/index.js';
import { ELanguage } from '../Utils/constants.js';
import { eventHelper } from './helper.js';
import { useReportCompany } from './hooks.js';
import { IconSuccess } from './icons.js';
import { ReportCompanySuccess } from './styles.css.js';

var OPEN_REPORT_SUCCESS_DIALOG = 'open-report-success-dialog';
var CLOSE_REPORT_SUCCESS_DIALOG = 'close-report-success-dialog';
var openReportSuccessDialog = function (locationClassName) {
    return new Promise(function (res, _) {
        eventHelper.emit("".concat(OPEN_REPORT_SUCCESS_DIALOG, "-").concat(locationClassName));
        eventHelper.on("".concat(CLOSE_REPORT_SUCCESS_DIALOG, "-").concat(locationClassName), function () {
            res(null);
        });
    });
};
var ReportCompanySuccessDialog = function () {
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = useReportCompany(), language = _b.language, t = _b.t, locationClassName = _b.locationClassName;
    var handleClose = function () {
        setIsOpen(false);
        eventHelper.emit("".concat(CLOSE_REPORT_SUCCESS_DIALOG, "-").concat(locationClassName));
    };
    useEffect(function () {
        var openDialogHandler = function () {
            setIsOpen(true);
        };
        eventHelper.on("".concat(OPEN_REPORT_SUCCESS_DIALOG, "-").concat(locationClassName), openDialogHandler);
        return function () {
            eventHelper.off("".concat(OPEN_REPORT_SUCCESS_DIALOG, "-").concat(locationClassName), openDialogHandler);
            eventHelper.off("".concat(CLOSE_REPORT_SUCCESS_DIALOG, "-").concat(locationClassName), function () { });
        };
    }, []);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Popup, { isShow: isOpen, onClickOutside: handleClose, onClose: handleClose, lang: language === 'vi' ? ELanguage.VI : ELanguage.EN, custom: {
                footer: React__default.createElement(React__default.Fragment, null),
                header: React__default.createElement(React__default.Fragment, null)
            }, styleOption: {
                size: 'sm'
            } },
            React__default.createElement(ReportCompanySuccess.Container, null,
                React__default.createElement(ReportCompanySuccess.Header, null,
                    React__default.createElement(ReportCompanySuccess.Action, { onClick: function () { return handleClose(); } },
                        React__default.createElement(RemoveIcon, null))),
                React__default.createElement(ReportCompanySuccess.Body, null,
                    React__default.createElement(ReportCompanySuccess.IconWrapper, null,
                        React__default.createElement(IconSuccess, null)),
                    React__default.createElement(ReportCompanySuccess.Title, null, t("Report a company successfully")),
                    React__default.createElement(ReportCompanySuccess.Description, null, t("Your comments make an important contribution to protecting the Company Seeker Community."))),
                React__default.createElement(ReportCompanySuccess.Footer, null,
                    React__default.createElement(ReportCompanySuccess.Button, { onClick: handleClose }, t("Close")))))));
};

export { ReportCompanySuccessDialog as default, openReportSuccessDialog };
//# sourceMappingURL=ReportSuccessDialog.js.map
